import * as React from "react";
import TopicGrid, { TopicItem } from "../common/TopicGrid";
import Content from "../common/Content";
import TopBox from "../common/TopBox";
import { ApiResult } from "../../lib/CmsApi";
import SectionList from "../sections/SectionList";
import Contacts from "../sections/Contacts";
import { sortByPositionField } from "../../lib/sort";
import EventSliderSection from "../sections/EventSlider";
import MagazineTeaserSection from "../sections/MagazineTeaserSection";

export type Props = {
  events?: ApiResult<"listExternalEvents">["items"];

  portraits: ApiResult<"listMagazinPortraits">;
  news: ApiResult<"listMagazinNews">;
} & ApiResult<"loadSegmentBySlug">;

export default function SegmentPage(props: Props) {
  const cluster = sortByPositionField(props.categoryClusters);
  return (
    <>
      <TopBox
        breadCrumpPath={[
          {
            title: props.name,
            route: "segment",
            params: { segment: props.slug }
          }
        ]}
        title={props.name}
        intro={props.intro}
        infoBox={<div />}
      />
      <main>
        <Content padded bottomMargin>
          <TopicGrid columns={3} tabletColumns={2} tinyColumns={1}>
            {cluster.map(cluster => {
              return (
                <TopicItem
                  key={cluster._id}
                  type="Themenbereich"
                  headline={cluster.name}
                  text={cluster.description && cluster.description}
                  cta="Zum Themenbereich"
                  image={cluster.header && cluster.header.image}
                  withFallbackImage
                  bigShadow
                  link={{
                    route: "categoryCluster",
                    params: {
                      categoryCluster: cluster.slug,
                      segment: props.slug
                    }
                  }}
                />
              );
            })}
          </TopicGrid>
        </Content>
        <Contacts
          headline="Wir sind für Sie da:"
          copy={`Wir beantworten Ihnen gerne Fragen zur Förderung für den Bereich „${props.name}“ und informieren Sie über die Angebote der IFB Hamburg.`}
          contacts={props.contacts}
          ariaLabel={`Ansprechpartner für den Bereich ${props.name}`}
        />
        <SectionList sections={props.contents} />
      </main>
      <aside>
        {props.events.length > 0 && (
          <EventSliderSection
            events={props.events}
            sectionProps={{ inSectionList: true }}
          />
        )}
        <MagazineTeaserSection
          overline={props.name}
          portraits={props.portraits}
          news={props.news}
          sectionProps={{ inSectionList: true }}
        />
      </aside>
    </>
  );
}

SegmentPage.getImages = (props: Props) => {
  let images = [];
  images = images.concat(
    props.categoryClusters.map(c => c.header && c.header.image).filter(Boolean)
  );
  images = images.concat(Contacts.getImages({ contacts: props.contacts }));
  images = images.concat(SectionList.getImages({ sections: props.contents }));
  images = images.concat(
    MagazineTeaserSection.getImages({
      news: props.news,
      portraits: props.portraits
    })
  );

  return images;
};
